"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignSpringGlobals = void 0;

var _reactSpring = require("react-spring");

const assignSpringGlobals = animatedGlobals => {
  _reactSpring.Globals.assign(animatedGlobals);
};

exports.assignSpringGlobals = assignSpringGlobals;